import { Grid, Skeleton, Stack, TableCell, Typography } from "@mui/material";
import List from "components/UI/List";
import { useAlert } from "contexts/alertContext";
import { Feature } from "models/api";
import React, { useCallback, useEffect, useState } from "react";
import { QueryClient } from "react-query";
import { generateColorGradient, handleError } from "helpers/utils";
import { useTranslation } from "react-i18next";
import {
  activeWorkshopsPerMonth,
  mandayPerMonthAndYear,
  mandayPerVenue,
  topNSubjects,
  trainerWorkshopByLanguage,
  trainerWorkshopByStatus,
  trainerWorkshopByTopic,
  vendorCompanyEngagment,
  vendorWorkshopByTopic,
  vendorWorkshopByTrainer,
  vendorWorkshopsByLocation,
  workshopsAttendance,
  workshopsPerProvider,
  workshopsStatusCount,
} from "framework/charts";
import { IChartView, IFormField, IOption } from "models/app";
import { CHARTS, InputTypes } from "constants/enums";
import ChartView from "components/UI/ChartView/ChartView";
import { TrainerWorkshopChartsCells, WorkshopChartsCells } from "framework/workshops";
import { IWorkshop } from "models/workshop";
import Filters from "./partials/filters";
import StackedBarChart from "./partials/stacked";
import { ChartData } from "chart.js";
import FormFields from "components/UI/FormFields";
import { useForm } from "react-hook-form";
import { getPermission, getUserData } from "helpers";
import { IPermission } from "models/permissions";
import EmptyContent from "components/EmptyContent";
import BlockIcon from "@mui/icons-material/Block";
interface Props {
  feature: Feature;
}

const VendorAnalytics: React.FC<Props> = ({ feature }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [loading3, setLoading3] = useState<boolean>(true);
  const [permission, setPermission] = useState<IPermission | null>(null);
  const { t, i18n } = useTranslation();
  const [yearStr, setYear] = useState<string[]>([
    new Date().getFullYear().toString(),
  ]);



  const [data1, setData1] = useState<any[]>([]);
  const [data2, setData2] = useState<any[]>([]);
  const [data3, setData3] = useState<any[]>([]);
  const [data4, setData4] = useState<any[]>([]);
  const [data5, setData5] = useState<any[]>([]);
  const [data6, setData6] = useState<any[]>([]);
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const [dateFrom, setDateFrom] = useState<any>(new Date(year, month, 1));
  const [dateTo, setDateTo] = useState<any>(new Date(year, month + 1, 0));
  const user = getUserData();
  const { colors: colors1 } = user;
  const colors: string[] = generateColorGradient(colors1?.chartMainColor);
  const { setAlert } = useAlert();

  // eslint-disable-next-line
  const queryClient = new QueryClient();

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {


      let promise1 = queryClient.fetchQuery(
        "Workshops By Location",
        () =>
          vendorWorkshopsByLocation(
            `?fromDate=${dateFrom!.toISOString()}&toDate=${dateTo!.toISOString()}`
          )
      );

      let promise2 = queryClient.fetchQuery(
        "Workshops by Company",
        () =>
          vendorCompanyEngagment(
            `?fromDate=${dateFrom!.toISOString()}&toDate=${dateTo!.toISOString()}`
          )
      );

      let promise3 = queryClient.fetchQuery(
        "Workshops by Topic",
        () =>
          vendorWorkshopByTopic(
            `?fromDate=${dateFrom!.toISOString()}&toDate=${dateTo!.toISOString()}`
          )
      );

      let promise4 = queryClient.fetchQuery(
        "Workshops by Trainer",
        () =>
          vendorWorkshopByTrainer(
            `?fromDate=${dateFrom!.toISOString()}&toDate=${dateTo!.toISOString()}`
          )
      );

      let promise5 = queryClient.fetchQuery(
        "Workshops by Language",
        () =>
          trainerWorkshopByLanguage(
            `?fromDate=${dateFrom!.toISOString()}&toDate=${dateTo!.toISOString()}`
          )
      );

      let promise6 = queryClient.fetchQuery(
        "top 5 Subjects",
        () =>
          topNSubjects(
            `?fromDate=${dateFrom!.toISOString()}&toDate=${dateTo!.toISOString()}&num=5`
          )
      );




      const [
        response1,
        response2,
        response3,
        response4,
        response5,
        response6,
      
      ] = await Promise.all([
        promise1,
        promise2,
        promise3,
        promise4,
        promise5,
        promise6,
    
      ]);
      setData1(response1);
      setData2(response2);
      setData3(response3);
      setData4(response4);
      setData5(response5);
     setData6(response6);

      setLoading(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading(false);
    }

    // eslint-disable-next-line
  }, [queryClient, setAlert]);

  const fetchPermission = useCallback(async () => {
    setLoading3(true);
    try {
      const res = await getPermission(21);
      setPermission(res);
      setLoading3(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading3(false);
    }

    // eslint-disable-next-line
  }, [queryClient, setAlert]);


  useEffect(() => {
    fetchData();
    fetchPermission();

    // eslint-disable-next-line
  }, [dateFrom, dateTo]);



  useEffect(() => {
    fetchPermission();

    // eslint-disable-next-line
  }, []);




  if (loading3)
    return (
      <Stack spacing={2} p={2}>
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton variant="rectangular" key={i} width="100%" height={30} />
        ))}
      </Stack>
    );

  if (!permission?.hasReadPermission)
    return (
      <EmptyContent
        icon={<BlockIcon sx={{ fontSize: "3.5rem " }} />}
        header={t("T_no_permissions")}
        message={t("T_no_permissions_message")}
      />
    );

  return (
    <Stack spacing={2} p={2}>
 

      <Grid
        container
        justifyContent={"space-between"}
        alignItems="center"
        
      >
        <Stack direction={"row"} spacing={1} sx={{ mb: 4 }}>
          <Filters
            onChangeFrom={(e) => setDateFrom(e)}
            onChangeTo={(e) => setDateTo(e)}
            valueFrom={dateFrom}
            valueTo={dateTo}
          />
        </Stack>
      </Grid>
      {loading ? (
        <Stack spacing={2} p={2}>
          {Array.from({ length: 10 }).map((_, i) => (
            <Skeleton variant="rectangular" key={i} width="100%" height={30} />
          ))}
        </Stack>
      ) : (
        <>
          {(() => {
            const chartData1: IChartView = {
              data: {
                Labels: (Array.isArray(data1) ? data1 : []).map((item: any) => item?.name),
                Values: (Array.isArray(data1) ? data1 : []).map((item: any) => item?.count),
              },
              label: t("T_vendor_dashboard_1"),
              type: CHARTS.BAR,
              backgroundColor: colors1?.chartMainColor || "#513cc7",
              borderColor: "#513cc7",
              Id: "mandayPerVendor",
            };

            const chartData2: IChartView = {
              data: {
                Labels: (Array.isArray(data2) ? data2 : []).map((item: any) => item?.name),
                Values: (Array.isArray(data2) ? data2 : []).map((item: any) => item?.count),
              },
              label: t("T_vendor_dashboard_2"),
              type: CHARTS.BAR,
              backgroundColor: colors1?.chartMainColor || "#513cc7",
              borderColor: "#513cc7",
              Id: "mandayPerVendor",
            };

            const chartData3: IChartView = {
              data: {
                Labels: (Array.isArray(data3) ? data3 : []).map((item: any) => item?.name),
                Values: (Array.isArray(data3) ? data3 : []).map((item: any) => item?.count),
              },
              label: t("T_vendor_dashboard_3"),
              type: CHARTS.PIE,
              backgroundColorPie: generateColorGradient(
                colors1?.chartMainColor,
                Array.isArray(data3) ? data3.length : 0
              ),
              borderColorPie: colors,
              Id: "workshopsStatusCount",
            };

            const chartData4: IChartView = {
              data: {
                Labels: (Array.isArray(data4) ? data4 : []).map((item: any) => item?.name),
                Values: (Array.isArray(data4) ? data4 : []).map((item: any) => item?.count),
              },
              label: t("T_vendor_dashboard_4"),
              type: CHARTS.BAR,
              backgroundColor: colors1?.chartMainColor || "#513cc7",
              borderColor: "#513cc7",
              Id: "mandayPerVendor",
            };

            const chartData5: IChartView = {
              data: {
                Labels: (Array.isArray(data5) ? data5 : []).map((item: any) => item?.name),
                Values: (Array.isArray(data5) ? data5 : []).map((item: any) => item?.count),
              },
              label: t("T_vendor_dashboard_5"),
              type: CHARTS.PIE,
              backgroundColorPie: generateColorGradient(
                colors1?.chartMainColor,
                Array.isArray(data5) ? data5.length : 0
              ),
              borderColorPie: colors,
              Id: "workshopsStatusCount",
            };

            const chartData6: IChartView = {
              data: {
                Labels: (Array.isArray(data6) ? data6 : []).map((item: any) => item?.name),
                Values: (Array.isArray(data6) ? data6 : []).map((item: any) => item?.topicCount),
              },
              label: t("T_vendor_dashboard_6"),
              type: CHARTS.BAR,
              backgroundColor: colors1?.chartMainColor || "#513cc7",
              borderColor: "#c3aaeb",
              Id: "top5subjects",
            };

            return (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <ChartView {...chartData1} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ChartView {...chartData2} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ChartView {...chartData3} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ChartView {...chartData4} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ChartView {...chartData5} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <ChartView {...chartData6} />
                </Grid>
              </Grid>
            );
          })()}
        </>
      )}

    </Stack>
  );
};

export default VendorAnalytics;
